import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Vendor } from 'models';

export interface VendorsState {
  status: string;
  vendors: Array<Vendor>;
}

const initialState: VendorsState = {
  status: '',
  vendors: [],
};

const vendorsSlice = createSlice({
  name: 'vendors',
  initialState,
  reducers: {
    updateVendors(state, action: PayloadAction<Array<Vendor>>) {
      state.status = 'fulfilled';
      state.vendors = action.payload;
    },
  },
});

export const { updateVendors } = vendorsSlice.actions;
export default vendorsSlice.reducer;
